const colors = {
  // Background light mode

  bg1: "#FBFFFE", //white
  bg2: "#85E0FF", // very light blue
  bg3: "#0E34A0", // some egyptian blue

  // text light mode

  text1: "#1A090D", // some xiketic black
  text2: "#636B61", // some ebony grey

  // In App Diary dark mode colors (default)
  dbg: "#26202b",
  dbg1: "#1A090D", 
  dbg2: "#636B61",

  dtext1: "#FBFFFE", //white
  dtext2: "#85E0FF", // very light blue
  dtext3: "#0E34A0", // some egyptian blue
};

export default colors;
